import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import Header from './components/Header';
import Player from './components/Player';
import Configurator from './components/Configurator';
import styled from 'styled-components';
import { initPlayer } from './modules/player';
import * as qs from 'query-string';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const Content = styled.div`
  display: flex;
  margin-top: 50px;
`;
const AppDisplay = styled.div`
  margin: auto;
  width: 80%;
  max-width: 1080px;
`;
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initConfig: undefined,
    };
  }

  async componentDidMount() {
    let initConfig;
    const { initPlayer } = this.props;
    try {
      initConfig = JSON.parse(
        qs.parse(this.props.location.search).configuration
      );
    } catch (e) {
      initConfig = undefined;
    }

    if (initConfig) {
      initPlayer(true);
      this.setState({ initConfig });
    }
  }

  render() {
    return (
      <AppDisplay>
        <Header />
        <Content>
          <Player initConfig={this.state.initConfig} />
          <Configurator />
        </Content>
      </AppDisplay>
    );
  }
}

const mapStateToProps = state => ({
  initialized: state.player.initialized,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      initPlayer,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.js